<template>
  <header class="sticky top-0 bg-genesys-primary shadow-lg">
    <nav class="container flex flex-col sm:flex-row items-center gap-4 text-white py-6">
    <RouterLink :to="{name: 'home'}">
      <div class="flex items-center gap-3" @click="toggleModal">
        <p class="text-2xl">Genesys</p>
      </div>
    </RouterLink>
      <div class="flex items-center gap-3" @click="toggleHelpModal">
        <p class="text-2xl">Help</p>
      </div>
      <div class="flex items-center gap-3" @click="audit">
        <p class="text-2xl">Audit</p>
      </div>
      <Menu as="div" class="relative ml-auto">
        <MenuButton class="relative flex rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">
          <span class="absolute -inset-1.5"></span>
          <span class="sr-only">Open user menu</span>
          <img class="size-8 rounded-full bg-gray-800 outline -outline-offset-1 outline-white/10" :src="authStore.user?.images?.find(img => img.resolution === 'x48')?.imageUri" :alt="authStore.user?.name" />
        </MenuButton>

        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-gray-800 py-1 outline -outline-offset-1 outline-white/10">
            <MenuItem v-slot="{ active }">
              <a href="#" :class="[active ? 'bg-white/5 outline-hidden' : '', 'block px-4 py-2 text-sm text-gray-300']">Your profile</a>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <a href="#" :class="[active ? 'bg-white/5 outline-hidden' : '', 'block px-4 py-2 text-sm text-gray-300']" @click="userSettings">Settings</a>
            </MenuItem>
            <MenuItem v-slot="{ active }">
              <a href="#" :class="[active ? 'bg-white/5 outline-hidden' : '', 'block px-4 py-2 text-sm text-gray-300']">Sign out</a>
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
      <BaseModal :modalActive="helpModalActive" @close-modal="toggleHelpModal">
          <Help/>
      </BaseModal>
    </nav>
  </header>
</template>

<script setup>
import { RouterLink, useRouter } from "vue-router"
import BaseModal from "@/components/BaseModal.vue";
import {ref} from "vue";
import Help from "@/components/Help.vue";
import api from "@/services/api.ts";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
import {useAuthStore} from "@/stores/authStore.ts";

const modalActive = ref(null);
const helpModalActive = ref(null);
const toggleModal = () => {
  modalActive.value = !modalActive.value;
}
const toggleHelpModal = () => {
  helpModalActive.value = !helpModalActive.value;
}

const router = useRouter()
const authStore = useAuthStore()

const userSettings = () => {
  router.push('/settings')
}

const audit = async () => {
  // const data = {
  //   serviceName: "ContactCenter",
  //   interval: "2024-11-30T00:00:00.000Z/2024-12-30T23:59:59.999Z",
  //   paging: {
  //     pageSize: 100,
  //     pageNumber: 1
  //   },
  //   filters: [
  //     { property: "EntityType", value: "Queue" },
  //     { property: "Action", value: "MemberUpdate" }
  //   ],
  //   sort: [
  //     { name: "Timestamp", sortOrder: "ascending" }
  //   ]
  // };

  try {

    await api.get('/audit/6fa6d6ff-7006-45f6-b5b0-2fbee0dccd9a');
  } catch (e) {
    console.error(e)
}

}
</script>